import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Navigation
    home: 'Inicio',
    explore: 'Explora',
    map: 'Mapa',
    weather: 'Tiempo',
    favorites: 'Favoritos',
    search: 'Buscar',
    admin: 'Admin',
    
    // Auth
    login: 'Iniciar sesión',
    register: 'Registrarse',
    logout: 'Cerrar sesión',
    email: 'Correo electrónico',
    password: 'Contraseña',
    name: 'Nombre',
    loginTitle: 'Bienvenido de nuevo',
    registerTitle: 'Crear cuenta',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    
    // Home
    heroTitle: 'Descubre Tenerife',
    heroSubtitle: 'La guía local con los mejores lugares de la isla',
    exploreButton: 'Explorar',
    featuredItineraries: 'Itinerarios destacados',
    popularActivities: 'Actividades populares',
    nearYou: 'Cerca de ti',
    
    // Explore
    categories: 'Categorías',
    allPlaces: 'Todos los lugares',
    noResults: 'No se encontraron resultados',
    
    // Place
    openInMaps: 'Abrir en Google Maps',
    addToFavorites: 'Añadir a favoritos',
    removeFromFavorites: 'Quitar de favoritos',
    reviews: 'reseñas',
    openingHours: 'Horario',
    phone: 'Teléfono',
    website: 'Sitio web',
    kmAway: 'km',
    
    // Weather
    weatherTitle: 'El tiempo en Tenerife',
    weatherSubtitle: 'Consulta las previsiones y webcams en directo',
    liveWebcam: 'Webcam en directo',
    windForecast: 'Previsión de viento',
    
    // Admin
    adminPanel: 'Panel de administración',
    addPlace: 'Añadir lugar',
    editPlace: 'Editar lugar',
    deletePlace: 'Eliminar lugar',
    searchGoogleMaps: 'Buscar en Google Maps',
    importFromGoogle: 'Importar desde Google',
    savePlace: 'Guardar lugar',
    
    // Common
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    back: 'Volver',
    seeAll: 'Ver todo',
    close: 'Cerrar',
  },
  en: {
    // Navigation
    home: 'Home',
    explore: 'Explore',
    map: 'Map',
    weather: 'Weather',
    favorites: 'Favorites',
    search: 'Search',
    admin: 'Admin',
    
    // Auth
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    loginTitle: 'Welcome back',
    registerTitle: 'Create account',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    
    // Home
    heroTitle: 'Discover Tenerife',
    heroSubtitle: 'The local guide with the best places on the island',
    exploreButton: 'Explore',
    featuredItineraries: 'Featured Itineraries',
    popularActivities: 'Popular Activities',
    nearYou: 'Near you',
    
    // Explore
    categories: 'Categories',
    allPlaces: 'All places',
    noResults: 'No results found',
    
    // Place
    openInMaps: 'Open in Google Maps',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    reviews: 'reviews',
    openingHours: 'Opening hours',
    phone: 'Phone',
    website: 'Website',
    kmAway: 'km',
    
    // Weather
    weatherTitle: 'Weather in Tenerife',
    weatherSubtitle: 'Check forecasts and live webcams',
    liveWebcam: 'Live webcam',
    windForecast: 'Wind forecast',
    
    // Admin
    adminPanel: 'Admin Panel',
    addPlace: 'Add place',
    editPlace: 'Edit place',
    deletePlace: 'Delete place',
    searchGoogleMaps: 'Search Google Maps',
    importFromGoogle: 'Import from Google',
    savePlace: 'Save place',
    
    // Common
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    seeAll: 'See all',
    close: 'Close',
  },
  de: {
    // Navigation
    home: 'Startseite',
    explore: 'Entdecken',
    map: 'Karte',
    weather: 'Wetter',
    favorites: 'Favoriten',
    search: 'Suche',
    admin: 'Admin',
    
    // Auth
    login: 'Anmelden',
    register: 'Registrieren',
    logout: 'Abmelden',
    email: 'E-Mail',
    password: 'Passwort',
    name: 'Name',
    loginTitle: 'Willkommen zurück',
    registerTitle: 'Konto erstellen',
    noAccount: 'Noch kein Konto?',
    hasAccount: 'Bereits ein Konto?',
    
    // Home
    heroTitle: 'Entdecke Teneriffa',
    heroSubtitle: 'Der lokale Führer mit den besten Orten der Insel',
    exploreButton: 'Entdecken',
    featuredItineraries: 'Empfohlene Routen',
    popularActivities: 'Beliebte Aktivitäten',
    nearYou: 'In deiner Nähe',
    
    // Explore
    categories: 'Kategorien',
    allPlaces: 'Alle Orte',
    noResults: 'Keine Ergebnisse gefunden',
    
    // Place
    openInMaps: 'In Google Maps öffnen',
    addToFavorites: 'Zu Favoriten hinzufügen',
    removeFromFavorites: 'Aus Favoriten entfernen',
    reviews: 'Bewertungen',
    openingHours: 'Öffnungszeiten',
    phone: 'Telefon',
    website: 'Webseite',
    kmAway: 'km',
    
    // Weather
    weatherTitle: 'Wetter auf Teneriffa',
    weatherSubtitle: 'Prognosen und Live-Webcams',
    liveWebcam: 'Live-Webcam',
    windForecast: 'Windvorhersage',
    
    // Admin
    adminPanel: 'Admin-Bereich',
    addPlace: 'Ort hinzufügen',
    editPlace: 'Ort bearbeiten',
    deletePlace: 'Ort löschen',
    searchGoogleMaps: 'Google Maps durchsuchen',
    importFromGoogle: 'Von Google importieren',
    savePlace: 'Ort speichern',
    
    // Common
    loading: 'Wird geladen...',
    error: 'Fehler',
    success: 'Erfolg',
    cancel: 'Abbrechen',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    back: 'Zurück',
    seeAll: 'Alle anzeigen',
    close: 'Schließen',
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  const getLocalizedField = (item, field) => {
    if (!item) return '';
    const localizedKey = `${field}_${language}`;
    return item[localizedKey] || item[`${field}_en`] || item[field] || '';
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, getLocalizedField }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
